import api from 'src/configs/api';
import queryString from 'query-string';
import { TSalesReportRequest } from 'src/types/Reports/salesReport.model';
import { TMarketingFeeReportRequest } from 'src/types/Reports/marketingFee.model';
import { TRefundRateReportRequest } from 'src/types/Reports/refundRate.model';
import { TOmicallReportQueryParams } from 'src/types/Reports/omicallReport.model';
import { TFilterDashboard } from 'src/types/Dashboard/Dashboard.model';
import { TBaseResponse } from 'src/types/Commons/filter.model';
import { TSummaryReportResponse } from 'src/types/Reports/summaryReport.model';
import { CustomerNewsReportQuery, ReportCustomerNews } from 'src/types/Reports/customerReport.model';
import { PageMessageStatisticQuery, ReportPageMessageStatistic } from 'src/types/Reports/pageReport.model';
import { PageUserMessageStatistic, PageUserMessageStatisticQuery } from 'src/types/Reports/pageUserReport.model';

const prefix = 'api/report';

export async function filterSalesReportByManager(param: TSalesReportRequest) {
  const query = queryString.stringify(param);
  const res = await api.get<TBaseResponse<TSummaryReportResponse[]>>(`${prefix}/sales-report-by-team?${query}`);
  return res.data;
}

export async function getReportTotalRevenueByYear(param: TFilterDashboard) {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/total-revenue?${query}`);
  return res.data;
}

export async function getReportTotalDashboard(param: TFilterDashboard) {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/total-dashboard?${query}`);
  return res.data;
}

export async function getRefundRateReportByManager(param: TRefundRateReportRequest) {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/refund-rate-report?${query}`);
  return res.data;
}

export const getOmicallReportByTeam = async (param: TOmicallReportQueryParams) => {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/omicall-report?${query}`);
    return res;
  } catch (errors: any) {
    return errors?.response;
  }
};

export const getProductDetailChart = async (param: TFilterDashboard) => {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/product-detail-chart?${query}`);
    return res.data;
  } catch (errors: any) {
    return errors?.response;
  }
};

export const getRatioProductAreaChart = async (param: TFilterDashboard) => {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/ratio-product-area?${query}`);
    return res.data;
  } catch (errors: any) {
    return errors?.response;
  }
};

export async function getDigitalMarketingFeeReportByManager(param: TMarketingFeeReportRequest) {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/digital-marketing?${query}`);
    return res.data;
  } catch (error: any) {
    return error?.response?.data;
  }
}
export async function getReportTotalRevenueByDay(param: TFilterDashboard) {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/total-revenue-by-day?${query}`);
  return res.data;
}
export async function getSummaryReportSale(param: TFilterDashboard):Promise<TBaseResponse<TSummaryReportResponse[]>> {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/summary-report-sales?${query}`);
  console.log(res)
  return res.data;
}
export async function getSummaryReportDigital(param: TFilterDashboard):Promise<TBaseResponse<TSummaryReportResponse[]>> {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/summary-report-digital?${query}`);
  return res.data;
}
export async function getCustomerNewReport(param: CustomerNewsReportQuery):Promise<TBaseResponse<ReportCustomerNews[]>> {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/customer-new-report?${query}`);
  return res.data;
}
export async function getPageMessageStatistic(param: PageMessageStatisticQuery):Promise<TBaseResponse<ReportPageMessageStatistic[]>> {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/page-message-report?${query}`);
  return res.data;
}
export async function getPageUserMessageStatistic(param: PageUserMessageStatisticQuery):Promise<TBaseResponse<PageUserMessageStatistic[]>> {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/page-user-message-report?${query}`);
  return res.data;
}